const ethnicities = [
    { id: '4', name: "Caucasian" },
    { id: '5', name: "Asian" },
    { id: '6', name: "Middle Eastern" },
    { id: '7', name: "Eurasian" },
    { id: '8', name: "African" },
    { id: '10', name: "Caribbean" },
    { id: '11', name: "Scandinavian European" },
    { id: '12', name: "Afro American" },
    { id: '13', name: "Latin American" },
    { id: '14', name: "European" },
    { id: '15', name: "Slavic European" },
    { id: '16', name: "American Indian" },
    { id: '17', name: "Inuit" },
    { id: '21', name: "Aboriginal/Torres Strait" },
    { id: '22', name: "Maori" },
    { id: '23', name: "Pacific Islander" },
    { id: '24', name: "Indian" },
    { id: '26', name: "Cambodian" },
    { id: '27', name: "Korean" },
    { id: '28', name: "Vietnamese" },
    { id: '29', name: "Thai" },
    { id: '30', name: "Chinese" },
    { id: '31', name: "Malaysian" },
    { id: '32', name: "Filipino" },
    { id: '33', name: "Japanese" },
    { id: '34', name: "Indonesian" },
    { id: '35', name: "Singaporean" },
    { id: '147', name: "Fijian" },
    { id: '148', name: "Tongan" },
    { id: '150', name: "Cook Islander" },
    { id: '156', name: "Northern European" },
    { id: '157', name: "Latin European" },
    { id: '158', name: "Central American" },
    { id: '159', name: "South American Indian" },
    { id: '160', name: "Hawaiian" },
    { id: '161', name: "East African" },
    { id: '162', name: "West African" },
    { id: '163', name: "Northern African" },
    { id: '164', name: "Eskimo" },
    { id: '165', name: "Arabic" },
    { id: '166', name: "Southern African" }
];

export default ethnicities;



// WEBPACK FOOTER //
// ./src/data/ethnicities.js